























































import Vue from 'vue';
import Layout from '@/layouts/_DefaultLayout.vue';
import { USER_CONFIRM_REQUEST, USERS_GET_REQUEST, USER_DELETE_REQUEST } from '../use-cases/manage-users/ManageUsersModule';

export default Vue.extend({
  name: 'Users',
  components: {
    Layout,
  },
  data() {
    return {
      error: '',
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Confirmed',
          value: 'isConfirmed',
        },
        {
          text: '',
          value: 'id',
        },
      ],
    };
  },
  computed: {
    users() {
      return this.$store.state.users.users;
    },
    currentUserId() {
      return this.$store.getters.userId;
    },
  },
  methods: {
    onClickConfirm(userId: number) {
      this.$store.dispatch(USER_CONFIRM_REQUEST, { userId })
        .catch(() => {
          this.error = 'An error ocurred confirming user';
        });
    },
    onClickDelete(userId: number) {
      this.$store.dispatch(USER_DELETE_REQUEST, userId)
        .catch(() => {
          this.error = 'An error ocurred deleting user';
        });
    },
  },
  created() {
    this.$store.dispatch(USERS_GET_REQUEST);
  },
});
